import type { JSX, ReactNode } from 'react';

import { cn } from '../lib/cn';
import { PILL_SHELL } from '../lib/pill-shell';

export type BadgeVariant = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

/**
 * Written out in full, one entry per variant, and never assembled from
 * pieces \u2014 Tailwind scans source text, it cannot see a class name built at
 * runtime (same reasoning as STATUS_STYLES in status-badge.tsx).
 */
const VARIANT_STYLES: Record<BadgeVariant, string> = {
  neutral: 'bg-slate-100 text-slate-700',
  primary: 'bg-primary-100 text-primary-700',
  success: 'bg-emerald-100 text-emerald-800',
  warning: 'bg-amber-100 text-amber-800',
  danger: 'bg-red-100 text-red-800',
  info: 'bg-sky-100 text-sky-800',
};

export interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

/** A generic label, unrelated to operational status \u2014 see StatusBadge for that. */
export function Badge({ variant = 'neutral', children, className }: BadgeProps): JSX.Element {
  return <span className={cn(PILL_SHELL, VARIANT_STYLES[variant], className)}>{children}</span>;
}
